module.exports = __webpack_public_path__ + "img/jiao.70f51ddb.png";